import { BaseBean } from './BaseBean';

export class UnidadOrganicaBean extends BaseBean{
    public id:number;
    public nombre:string;
    public unidadOrganicaPadre:UnidadOrganicaBean
    public idUnidadOrganicaPadre:number
    public nivel:string;
    public children: UnidadOrganicaBean[];
    public expanded:boolean;
    public abreviatura:string;
}
